$(document).ready(function() {
  let option_not_fills = $('.product-form__input input:checked').val();
   setTimeout(function() {
    if(option_not_fills == 'Not Personalised') {
      $('.product__media-wrapper').addClass('non-personalised-img');
      const listItemCount = $('.thumbnail-slider ul li').length;
      if(listItemCount >= 3) {
        $('.thumbnail-slider ul li:eq(2) button').click();
      }else {
        $('button.slider-button.slider-button--next').click();
      }
      //$('button.slider-button.slider-button--next').click();  
    }
   }, 3500);
});  
$(document).on('click', '.personalised-pro .product-form__input label', function() {
  var option_label = $(this).clone().children().remove().end().text().trim();
  if(option_label == 'Personalised') {
    setTimeout(function() {
     location.reload();
    }, 500);  
  }else if(option_label == 'Not Personalised') {
    setTimeout(function() {
        $('.product__media-wrapper').addClass('non-personalised-img');
        const listItemCount = $('.thumbnail-slider ul li').length;
        if(listItemCount >= 3) {
          $('.thumbnail-slider ul li:eq(2) button').click();
        }else {
          $('button.slider-button.slider-button--next').click();
        }
        //$('button.slider-button.slider-button--next').click();
    }, 1000);
  }
  // else {
  //   setTimeout(function() {
  //   $('button.slider-button.slider-button--next').click();
  //   }, 500);  
  // }
  setTimeout(function() {
  $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').hide();
     $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }, 500); 
});  
  
$(document).on('click', '.personalised-pro .product-form__input .price-per-item__container .quantity__button[name="plus"]', function() {
  const plus_quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
  let plus_currentQuantitys = parseInt(plus_quantityInput.val()) || 0;
  let option_not_fill = $('.product-form__input input:checked').val();
  if(plus_currentQuantitys >= 2 && option_not_fill != 'Not Personalised') {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').show();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }else {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').hide();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }
});
$(document).on('click', '.personalised-pro .product-form__input .price-per-item__container .quantity__button[name="minus"]', function() {
  const minus_quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let minus_currentQuantitys = parseInt(minus_quantityInput.val()) || 0;
   let option_not_fill = $('.product-form__input input:checked').val();
  if(minus_currentQuantitys >= 2 && option_not_fill != 'Not Personalised') {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').show();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }else {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').hide();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }
});  
 
  $(document).on('click', '.cart_plus_ten .plus_ten .quantity__button[name="plus"]', function() {
    const steps_plus = 10;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
    let currentQuantity = currentQuantitys - 1;
    quantityInput.val(currentQuantity + steps_plus); // Increase by 10
  });
  
  $(document).on('click', '.cart_plus_ten .plus_ten .quantity__button[name="minus"]', function() {
    const steps = 10;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
    console.log(currentQuantitys);
     let currentQuantity = currentQuantitys + 1;
    if (currentQuantity > steps) {
      quantityInput.val(currentQuantity - steps); // Decrease by 10
    }
  });
  
  $(document).on('click', '.cart_golf_ball_bundle .cart_golf_ball_inc .quantity__button[name="plus"]', function() {
    const golf_steps = 12;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
    let currentQuantity = currentQuantitys - 1;
    quantityInput.val(currentQuantity + golf_steps); // Increase by 10
  });
  
  $(document).on('click', '.cart_golf_ball_bundle .cart_golf_ball_inc .quantity__button[name="minus"]', function() {
    const golf_steps = 12;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
     let currentQuantity = currentQuantitys + 1;
    if (currentQuantity > golf_steps) {
      quantityInput.val(currentQuantity - golf_steps); // Decrease by 10
    }
  });  